module.exports = __webpack_public_path__ + "img/16d004-16.fbd66c64.png";